/** Final Payroll column value: whole units, en-US grouping. */
export const formatFinalPayroll = (value) =>
  Number(value || 0).toLocaleString("en-US", {
    maximumFractionDigits: 0,
  });

export default formatFinalPayroll;
